module.exports = __webpack_public_path__ + "static/img/14000787.90d310e8.png";